module.exports = __webpack_public_path__ + "img/cabinet-filing.75fe4fb5.svg";